export default __webpack_public_path__ + "static/phone-therapy-60c81bc06bfd9bfbc056a45a51e03ef1.webp";